module.exports = __webpack_public_path__ + "static/img/logo_header.8c276c91.png";